import { msg } from '@lingui/macro'

/**
 * Messaggio utente per errori API Stats / crash dataset.
 * @param {{ responseMessage?: string, responseCode?: number }} response
 * @param {(descriptor: import('@lingui/macro').MessageDescriptor) => string} translate
 * @returns {string}
 */
export function formatStatsApiError(response, translate) {
  const raw = String(response?.responseMessage ?? '').trim()

  if (/INVALID_PARAMETER/i.test(raw) || /basicOrganization/i.test(raw)) {
    return translate(
      msg`Cannot combine a specific organization with a data category. Use report type Merged or clear the category filter.`,
    )
  }

  if (/SENSITIVE/i.test(raw) || /sensitive field/i.test(raw)) {
    return translate(
      msg`This field is marked as sensitive and cannot be used in charts.`,
    )
  }

  if (/FORBIDDEN|403|not allowed/i.test(raw)) {
    return translate(msg`You are not allowed to access this dataset.`)
  }

  return raw || translate(msg`Statistics request failed.`)
}
